export default {
    "frames": [
        {
            "time": 0,
            "image": require("./sprite-gwyn1.png")
        },
        {
            "time": 1 * 100,
            "image": require("./sprite-gwyn2.png")
        },
        {
            "time": 2 * 100,
            "image": require("./sprite-gwyn3.png")
        },
        {
            "time": 3 * 100,
            "image": require("./sprite-gwyn4.png")
        },
        {
            "time": 4 * 100,
            "image": require("./sprite-gwyn5.png")
        },
        {
            "time": 5 * 100,
            "image": require("./sprite-gwyn6.png")
        },
        {
            "time": 6 * 100,
            "image": require("./sprite-gwyn7.png")
        },
        {
            "time": 7 * 100,
            "image": require("./sprite-gwyn8.png")
        },
        {
            "time": 8 * 100,
            "image": require("./sprite-gwyn9.png")
        },
        {
            "time": 9 * 100,
            "image": require("./sprite-gwyn10.png")
        },
        {
            "time": 10 * 100,
            "image": require("./sprite-gwyn11.png")
        },
        {
            "time": 11 * 100,
            "image": require("./sprite-gwyn12.png")
        },
        {
            "time": 12 * 100,
            "image": require("./sprite-gwyn13.png")
        },
        {
            "time": 13 * 100,
            "image": require("./sprite-gwyn14.png")
        },
        {
            "time": 14 * 100,
            "image": require("./sprite-gwyn15.png")
        },
        {
            "time": 15 * 100,
            "image": require("./sprite-gwyn16.png")
        },
        {
            "time": 16 * 100,
            "image": require("./sprite-gwyn17.png")
        },
        {
            "time": 17 * 100,
            "image": require("./sprite-gwyn18.png")
        },
        {
            "time": 18 * 100,
            "image": require("./sprite-gwyn19.png")
        },
        {
            "time": 19 * 100,
            "image": require("./sprite-gwyn20.png")
        },
        {
            "time": 20 * 100,
            "image": require("./sprite-gwyn21.png")
        },
        {
            "time": 21 * 100,
            "image": require("./sprite-gwyn22.png")
        },
        {
            "time": 22 * 100,
            "image": require("./sprite-gwyn23.png")
        },
        {
            "time": 23 * 100,
            "image": require("./sprite-gwyn24.png")
        },
        {
            "time": 24 * 100,
            "image": require("./sprite-gwyn25.png")
        },
        {
            "time": 25 * 100,
            "image": require("./sprite-gwyn26.png")
        },
        {
            "time": 26 * 100,
            "image": require("./sprite-gwyn27.png")
        },
        {
            "time": 27 * 100,
            "image": require("./sprite-gwyn28.png")
        },
    ]
}
